import { Text } from '@billy/design-system'

import { ReportSkeleton } from '../../../../../../reports/elements/ReportSkeleton'
import { ReportTable } from '../../../../../elements/ReportTable'
import { useProfitAndLossData } from '../../hooks/useProfitAndLossData'
import { PeriodsHeader } from '../PeriodsHeader'
import { ProfitAndLossTableBody } from '../ProfitAndLossTableBody'
import * as Styled from './styled'

const periodsMock = [
  { key: 2025, label: 2025 },
  { key: 2024, label: 2024 },
]

export const ProfitAndLossTable = () => {
  const { allExpandableIds, isLoading, reportData, periods } = useProfitAndLossData()

  if (isLoading || !allExpandableIds) {
    return (
      <ReportSkeleton
        headerChildren={
          <>
            {periodsMock.map(({ key, label }) => (
              <Styled.HeaderCell key={key}>
                <Text weight="bold">{label}</Text>
              </Styled.HeaderCell>
            ))}
          </>
        }
        columnWidths={[200, 120, 120]}
      />
    )
  }

  return (
    <ReportTable allExpandableIds={allExpandableIds} header={<PeriodsHeader periods={periods} />}>
      <ProfitAndLossTableBody reportData={reportData} periods={periods} />
    </ReportTable>
  )
}
